import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { FadeUp, MaskText } from "./Reveal";
import { money } from "../context/ShopContext";

export const inputCls =
  "w-full bg-[#fbf8f1] border border-cream-border px-4 py-3 text-[#201a12] placeholder:text-[#9b8e7c] focus:border-gold focus:outline-none transition-colors text-sm";

export const labelCls = "block text-[0.65rem] uppercase tracking-[0.18em] text-ink-muted mb-2";

export const ShopHero = ({ eyebrow, lines, blurb }) => (
  <section className="bg-cream pt-36 pb-16 md:pt-44 md:pb-20" data-testid="shop-hero">
    <div className="max-w-[1400px] mx-auto px-6 md:px-10">
      <FadeUp><p className="eyebrow mb-6">{eyebrow}</p></FadeUp>
      <h1 className="font-serif text-5xl sm:text-6xl lg:text-[4.5rem] leading-[0.95] tracking-tight text-ink max-w-3xl">
        <MaskText lines={lines} delay={0.15} />
      </h1>
      {blurb && (
        <FadeUp delay={0.3}>
          <p className="text-ink-muted text-base md:text-lg leading-relaxed mt-8 max-w-xl">{blurb}</p>
        </FadeUp>
      )}
    </div>
  </section>
);

export const ProductCard = ({ p, index = 0 }) => (
  <FadeUp delay={(index % 4) * 0.07}>
    <Link
      to={`/shop/${p.slug}`}
      className="group block border border-cream-border bg-[#fbf8f1] hover:border-gold transition-colors duration-500"
      data-testid={`product-card-${p.slug}`}
    >
      <div className="relative aspect-square overflow-hidden bg-[#f4eee2]">
        <img
          src={p.image}
          alt={p.name}
          className="absolute inset-0 w-full h-full object-cover transition-transform duration-[900ms] ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:scale-105"
        />
      </div>
      <div className="p-6">
        <h3 className="font-serif text-xl text-ink leading-snug">{p.name}</h3>
        {p.subtitle && <p className="text-xs text-ink-muted mt-2 leading-relaxed line-clamp-2">{p.subtitle}</p>}
        <div className="flex items-center justify-between mt-5">
          <span className="flex items-baseline gap-2">
            <span className="font-serif text-lg text-ink" data-testid={`product-price-${p.slug}`}>
              {money(p.price)}{p.billing_interval ? ` / ${p.billing_interval}` : ""}
            </span>
            {p.compare_price > p.price && (
              <span className="text-xs text-ink-muted line-through">{money(p.compare_price)}</span>
            )}
          </span>
          <span className="inline-flex items-center gap-2 text-gold text-[0.65rem] font-semibold uppercase tracking-[0.2em]">
            View <ArrowRight size={12} className="group-hover:translate-x-1 transition-transform duration-300" />
          </span>
        </div>
      </div>
    </Link>
  </FadeUp>
);
